<template>
<el-select
  v-model="years"
  multiple
  size="small"
  style="width:107px;"
  @change="onSelectChanged"
>
  <el-option
    v-for="option in filterOptions"
    :key="option.value"
    :value="option.value"
    :label="option.label"
  />
</el-select>
</template>

<script>
const PROJECT_START_YEAR = process.env.PROJECT_START_YEAR

export default {
  name: 'CompareTimeYear',
  props: {
    filterYears: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      years: [new Date().getFullYear()]
    }
  },
  computed: {
    projectStartYear: () => PROJECT_START_YEAR,
    options () {
      let {projectStartYear} = this
      let nowYear = new Date().getFullYear()
      return new Array(nowYear - projectStartYear + 1).fill(projectStartYear).map((year, index) => ({
        value: year + index,
        label: `${year + index}年`
      })).sort((a, b) => b.value - a.value)
    },
    filterYearMap () {
      return this.filterYears.reduce((map, year) => {
        map[year] = true
        return map
      }, {})
    },
    filterOptions () {
      let {filterYearMap} = this
      return this.options.filter(option => !filterYearMap.hasOwnProperty(option.value))
    },
    optionMap () {
      return this.filterOptions.reduce((map, option) => {
        map[option.value] = option
        return map
      }, {})
    }
  },
  methods: {
    onSelectChanged (years) {
      this.$emit('on-years-changed', years)
    }
  },
  created () {
    let {filterOptions} = this

    if (filterOptions.length > 0) {
      this.years = [filterOptions[0].value]
      this.$emit('on-years-changed', this.years)
    }
  },
  watch: {
    optionMap (newVal) {
      let years = this.years.filter(year => newVal.hasOwnProperty(year))

      if (years.length !== this.years) {
        this.years = years
        this.$emit('on-years-changed', years)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  /deep/ {
    .el-select__tags {
      height: 32px;
      align-items: center;
      flex-wrap: nowrap;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/CompareTime/Year.vue